import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { BrandLogo } from '../../components/domain/brand-logo';
import { RecipeSection } from '../../components/domain/recipe-section';
import { RecipeForm } from '../../components/domain/recipe-form';

const sectionTitleStyle: React.CSSProperties = {
  fontFamily: '"Noto Serif SC", "Songti SC", serif',
};

const bodyFontStyle: React.CSSProperties = {
  fontFamily: 'Montserrat, "PingFang SC", "Microsoft YaHei", sans-serif',
};

const RecipesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#000000] text-white" style={bodyFontStyle}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;700&family=Montserrat:wght@300;400;500;700&display=swap');`}</style>

      <nav className="sticky left-0 top-0 z-40 w-full border-b border-white/10 bg-black/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-[1440px] items-center justify-between px-5 py-5 md:px-10">
          <Link to="/" className="shrink-0">
            <BrandLogo iconClassName="h-10 w-10 sm:h-11 sm:w-11" titleClassName="text-lg sm:text-xl md:text-2xl" subtitleClassName="text-[9px] sm:text-[10px]" />
          </Link>

          <Link
            to="/"
            className="inline-flex items-center gap-2 border border-[#FFC000]/40 px-4 py-2 text-xs font-medium tracking-[0.18em] text-[#FFC000] transition-colors hover:bg-[#FFC000] hover:text-black"
          >
            <ChevronLeft className="h-4 w-4" />
            返回首页
          </Link>
        </div>
      </nav>

      <main>
        <section className="relative overflow-hidden border-b border-white/10 bg-[radial-gradient(circle_at_top,rgba(255,192,0,0.16),transparent_42%),linear-gradient(180deg,#050505_0%,#0b0b0b_100%)] px-5 pb-16 pt-24 md:px-10 md:pb-20 md:pt-28">
          <div className="mx-auto max-w-[1200px]">
            <div className="mb-6 flex items-center gap-3 text-xs tracking-[0.2em] text-white/45">
              <Link to="/" className="transition-colors hover:text-[#FFC000]">
                首页
              </Link>
              <span className="text-white/25">/</span>
              <span className="text-[#FFC000]">基础配方</span>
            </div>

            <div className="max-w-3xl">
              <div className="mb-5 inline-block border border-[#FFC000]/60 px-4 py-1 text-[11px] tracking-[0.35em] text-[#FFC000]">
                配方目录
              </div>
              <h1 className="mb-5 text-4xl text-white md:text-6xl" style={sectionTitleStyle}>
                基础配方
              </h1>
              <div className="mb-4 text-sm tracking-[0.34em] text-[#FFC000] md:text-base">16款合作鸡尾酒配方</div>
              <div className="max-w-2xl text-base leading-8 text-white/72 md:text-lg">
                围绕元酒梦 2021 君系列延展的合作配方集合，适用于酒单共创、风味实验与高端酒吧场景表达。
              </div>
            </div>
          </div>
        </section>

        <RecipeSection />
        <RecipeForm />
      </main>
    </div>
  );
};

export default RecipesPage;
